var site = site || {};

(function ($) {
  /**
   * Basic collapsible-menu behavior for small screen living aveda.
   */
  Drupal.behaviors.LAHeaderV1 = {
    attach: function (context) {
      var $formatter = $('.la-header--v1', context);
      var $formatterTouch = $('.la-header--v1', 'html.touchevents');
      var $headerMain = $('.js-site-header-main', context);
      var $body = $('body', context);

      if (!$formatter.length) {
        return;
      }

      // mobile menu
      var $blockMobile = $formatter.find('.js-la-header__menu--mobile', context);
      var $triggerMobile = $blockMobile.find('.js-la-menu-trigger');
      var $menuMobile = $blockMobile.find('.js-la-menu--mobile');
      var $navMobileTrigger = $menuMobile.find('.menu__link--has-children');
      // pc and landscape-up menu
      var $blockPC = $formatter.find('.js-la-header__menu--pc', context);
      var $stickyPC = $formatter.find('.js-la-header__menu--pc--sticky', context);
      var $menuPC = $blockPC.find('.js-la-menu--pc');
      var $menuPCItem = $menuPC.find('.menu__item--lvl-1');
      // touch events widescreen
      var $blockTouch = $formatterTouch.find('.js-la-header__menu--pc', context);
      var $menuTouch = $blockTouch.find('.js-la-menu--pc');
      var $TouchItemLinks = $menuTouch.find('.menu__link--lvl-1');
      var siteHeaderHeight = $headerMain.outerHeight(true);

      $stickyPC.css('top', (siteHeaderHeight + 1) + 'px');
      // mobile menu interactions
      $blockMobile.each(function () {
        // menu container expansion
        $triggerMobile.unbind('click').on('click keydown', function () {
          $blockMobile.toggleClass('menu-active');
        });
        // submenu expansion
        $navMobileTrigger.unbind('click').on('click keydown', function (event) {
          event.preventDefault();
          $(this).closest('.menu__item--lvl-1').toggleClass('submenu-active');
          $(this).next('.menu--lvl-2').toggleClass('submenu-active');
        });
      });

      $TouchItemLinks.each(function () {
        // Touch devices use click event for primary nav:
        $(this).on('click', function (event) {
          var $touchItemSubLinks = $('.menu__link--has-children', '.parent-active');

          if ($touchItemSubLinks.length) {
            event.preventDefault();
          }
          $TouchItemLinks.not(this).removeClass('parent-active');
          $(this).parent().addClass('parent-active');
        });
      });

      // pc menu interactions
      $menuPCItem.each(function () {
        // For Living Aveda menu items
        if ($(this).children().length > 1) {
          $(this).attr({
            tabindex: 0,
            'aria-expanded': 'false',
            'aria-haspopup': 'true',
            role: 'menu',
            'aria-label': $(this).find('> :first').text()
          });
          if ($(this).find('> a').length > 0) {
            $(this).find('> a').attr({
              tabindex: '-1',
              'aria-hidden': 'true'
            });
          }
        }

        // Non-touch devices use mouseenter/leave:
        $(this).on('mouseenter', function () {
          $(this).addClass('parent-active').attr('aria-expanded', 'true');
        });

        $(this).on('mouseleave', function () {
          $(this).removeClass('parent-active').attr('aria-expanded', 'false');
        });

        $(this).on('keydown', function (e) {
          if (site.getKeycode(e) === 13) {
            e.preventDefault();
            e.stopPropagation();
            $(this).trigger('mouseover');
          }
        });
      });
      // Submenu Navigation - Sticky
      $subMenuElement = $('.menu__item--lvl-2', $('.js-la-menu--pc'));
      $subMenuElement.focusout(function (e) {
        if ($(this).closest('.last').parents('.parent-active')) {
          $(this).closest('.last').parents('.parent-active').removeClass('parent-active');
        }
      });
      // Hiding sticky nav menu for ada implementation
      $(document).on('ready', function () {
        $stickyPC.find(':focusable').attr('tabindex', '-1');
      });
      $(window).on('layout.adjustContentPosition', function (e, height) {
        siteHeaderHeight = $body.hasClass('site-header-formatter--hidden') ? 0 : height;
        $stickyPC.css('top', siteHeaderHeight + 'px');
      });
      // Sticky nav
      $(document).on(
        'scroll',
        _.throttle(function () {
          var y = $(document).scrollTop();
          var blockOffset = $blockPC.offset();
          var blockTop = blockOffset?.top ? blockOffset.top : 0;

          $stickyPC.toggleClass('pinned', y > blockTop - siteHeaderHeight);
        }, 125)
      );
    }
  };
})(jQuery);
